<template>
  <v-menu
    ref="dateMenu"
    v-model="dateMenu"
    :attach="true"
    :close-on-content-click="false"
    :allow-overflow="true"
    content-class="custom-date-picker"
    nudge-top="10"
    :nudge-right="isMobile ? -24 : 12"
    :bottom="!top"
    :top="top"
    transition="scroll-y-transition"
    max-width="355"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="computedDateFormatted"
        v-bind="attrs"
        dense
        filled
        rounded
        solo
        flat
        readonly
        hint="DD/MM/YYYY format"
        class="text-input"
        hide-details
        prepend-inner-icon="mdi-calendar"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="startDate"
      no-title
      locale="ro"
      :min="minDate"
      :max="maxDate"
      first-day-of-week="1"
      @input="selectDate"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DateQuestion',
  props: {
    top: Boolean
  },
  data() {
    return {
      dateMenu: false,
      startDate: null,
      minDate: new Date().toISOString().substring(0, 11)
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 960;
    },
    maxDate() {
      const today = new Date();
      today.setFullYear(today.getFullYear() + 1);
      return today.toISOString().substring(0, 11);
    },
    computedDateFormatted() {
      return this.formatDate(this.startDate);
    }
  },
  methods: {
    selectDate() {
      this.dateMenu = false;
      this.updateEvent();
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    updateEvent() {
      const data = {
        startDate: this.startDate,
        formattedDate: this.formatDate(this.startDate)
      };
      setTimeout(() => {
        this.$emit('updateDate', {
          data,
          isValid: !!(this.startDate)
        });
      }, 350);
    }
  }
};
</script>

<style scoped>
.text-input {
  border-radius: 4px;
  width: 355px;
}
.text-input ::v-deep input {
  border: none;
}
@media screen and (max-width: 600px) {
  .text-input {
    width: 100%;
    min-width: 260px;
  }
}
.custom-date-picker ::v-deep table td, .custom-date-picker ::v-deep table th {
  padding: 0;
  border: none;
}
.custom-date-picker ::v-deep button {
  padding: 0;
}
.custom-date-picker ::v-deep button:hover {
  border-color: transparent;
  background: transparent;
}
</style>
